import React from 'react';

/**
 * AdminSaveDialog component for admin to provide a shared reason when batch saving picks
 */
const AdminSaveDialog = ({
  show,
  selectedUser,
  saveReason,
  saving,
  changedCount,
  onReasonChange,
  onConfirm,
  onCancel,
}) => {
  if (!show) return null;

  const userName = selectedUser?.display_name || selectedUser?.username || 'this user';

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Save Picks for {userName}</h3>
        <p>
          You are saving <strong>{changedCount}</strong> pick change{changedCount !== 1 ? 's' : ''} for{' '}
          <strong>{userName}</strong>. Please provide a reason:
        </p>
        <textarea
          value={saveReason}
          onChange={(e) => onReasonChange(e.target.value)}
          placeholder="E.g., User requested changes via email"
          rows={4}
          className="reason-textarea"
          autoFocus
        />
        <div className="modal-buttons">
          <button
            onClick={onConfirm}
            disabled={!saveReason.trim() || saving}
            className="btn-confirm"
          >
            {saving ? 'Saving...' : 'Save All Picks'}
          </button>
          <button onClick={onCancel} className="btn-cancel" disabled={saving}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminSaveDialog;
